import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000/api/v2';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

export default axiosInstance;
